// Module
var code = "<fieldset [id]=\"controlId\" class=\"ndd-ng-form-fieldset\" [disabled]=\"controlDisabled\"> <legend class=\"ndd-ng-form-fieldset__legend\">{{ controlLegend }}</legend> <p class=\"ndd-ng-form-fieldset__description\">{{ controlDescription }}</p> <div class=\"ndd-ng-form-fieldset__controls\"> <ng-content></ng-content> </div> </fieldset> ";
// Exports
module.exports = code;